
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class StatusChip extends Vue {
  @Prop({ type: String, required: true })
  public status!: string;

  public get label(): string {
    return (this.status || '').toUpperCase();
  }

  public get color(): string {
    const status = (this.status || '').toLowerCase();

    switch (status) {
      case 'active':
      case 'done':
      case 'up':
        return 'success';
      case 'disabled':
      case 'cancelled':
      case 'rolled back':
      case 'queued':
        return 'orange';
      case 'error':
      case 'failed':
      case 'down':
        return 'error';
      case 'pending':
      case 'in progress':
      case 'creating':
      case 'deleting':
      case 'retry':
      case 'retrying':
      case 'rolling back':
        return 'info';
      default:
        return 'grey';
    }
  }
}
